export const TASK_ROW_HEIGHT = 52;
